import { render } from "./CompanyModule.vue?vue&type=template&id=45cf773e&scoped=true"
import script from "./CompanyModule.vue?vue&type=script&lang=js"
export * from "./CompanyModule.vue?vue&type=script&lang=js"

import "./CompanyModule.vue?vue&type=style&index=0&id=45cf773e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45cf773e"],['__file',"src/views/overlatelser/OvApplicationView/CompanyModule.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45cf773e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45cf773e', __exports__)) {
    api.reload('45cf773e', __exports__)
  }
  
  module.hot.accept("./CompanyModule.vue?vue&type=template&id=45cf773e&scoped=true", () => {
    api.rerender('45cf773e', render)
  })

}


export default __exports__